import { Profile } from '../types/pilot';
import { Profile as UProfile } from '../types/user';

export const getProfileName = (profile: Profile | UProfile) => {
  if (!profile) {
    return '';
  }
  return profile.PreferredName || `${profile.FirstName} ${profile.LastName}`;
};
